// extracted by mini-css-extract-plugin
export var colorSquare = "_ry-0";
export var danger = "_ry-5";
export var lightPink = "_ry-8";
export var neutralBlue = "_ry-7";
export var neutralYellow = "_ry-6";
export var normal = "_ry-1";
export var primary = "_ry-2";
export var primaryLight = "_ry-3";
export var solidBlack = "_ry-g";
export var solidGreen = "_ry-b";
export var solidLightBlue = "_ry-d";
export var solidNavy = "_ry-c";
export var solidOrange = "_ry-f";
export var solidPink = "_ry-e";
export var solidRed = "_ry-9";
export var solidYellow = "_ry-a";
export var success = "_ry-4";